import { paths } from "app/constants/paths";

export const COMMS_HUB_SCOPE = "0";

export const EMAIL_PROFILE_NAME = "email";
export const SLACK_PROFILE_NAME = "slack";
export const JIRA_PROFILE_NAME = "jira";
export const SERVICE_NOW_PROFILE_NAME = "servicenow";
export const TEAMS_PROFILE_NAME = "msteams";
export const DATADOG_PROFILE_NAME = "datadog";

export const RESOURCE_OWNER_PROFILE_NAME = "resource_owner";
export const ACCOUNT_OWNER_PROFILE_NAME = "account_owners";

export const EMAIL_INTEGRATION_PATH = paths.settingsIntegrationsEmail;
export const EMAIL_BREADCRUMB = {
  label: "Email",
  target: EMAIL_INTEGRATION_PATH,
};

export const JIRA_INTEGRATION_PATH = paths.settingsIntegrationsJira;
export const JIRA_BREADCRUMB = {
  label: "Jira",
  target: JIRA_INTEGRATION_PATH,
};

export const SERVICE_NOW_INTEGRATION_PATH =
  paths.settingsIntegrationsServiceNow;
export const SERVICE_NOW_BREADCRUMB = {
  label: "ServiceNow",
  target: SERVICE_NOW_INTEGRATION_PATH,
};

/**
 * Query variables shared by the ServiceNow index and configure roots. Both
 * queries must request the profiles connection with identical arguments so
 * they normalize to the same Relay store record — the form's mutation updater
 * targets that connection via `connections: [__id]`.
 */
export const SERVICE_NOW_PROFILES_VARIABLES = {
  scope: COMMS_HUB_SCOPE,
  first: 100,
};

export const TEAMS_INTEGRATION_PATH = paths.settingsIntegrationsTeams;
export const TEAMS_BREADCRUMB = {
  label: "Microsoft Teams",
  target: TEAMS_INTEGRATION_PATH,
};

export const DATADOG_INTEGRATION_PATH = paths.settingsIntegrationsDatadog;
export const DATADOG_BREADCRUMB = {
  label: "Datadog",
  target: DATADOG_INTEGRATION_PATH,
};

export const SLACK_FORM_DESCRIPTION = `Slack can be configured either via a token or by adding one or more
webhooks. Using a token imports your whole workspace and allows for
sending direct messages. Using a webhook allows for adding individual
channels.`;
